import { CommentInput } from "./CommentInput";
import { CommentList } from "./CommentList";
import { ClientProcess } from "@avenueops/shared-types";
import React from "react";
import { useForm } from "react-hook-form";

interface Props {
  process: ClientProcess;
  small?: boolean;
}

export function ProcessPageComments({ process, small }: Props) {
  return (
    <>
      <CommentInput process={process} />
      <CommentList process={process} small={small} />
    </>
  );
}
